module.exports = __webpack_public_path__ + "static/media/oops.95a39734.svg";